// src/components/AuthNav.jsx
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../providers/AuthProvider'
import LogoutButton from './LogoutButton'

export default function AuthNav() {
  const nav = useNavigate()
  const { user, loading } = useAuth()

  // 로딩 중이더라도 이미 user 정보가 있으면 바로 표시 (끊김 없는 UX)
  // user가 없고 로딩 중인 경우만 로딩 안내 표시
  if (loading && !user) {
    return (
      <div className="flex items-center gap-2">
        <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
        <span className="text-xs text-gray-400">확인 중...</span>
      </div>
    )
  }

  if (!user) {
    return (
      <div className="flex items-center gap-3">
        <Link to="/login" className="hover:underline text-sm text-gray-700">
          로그인
        </Link>
        <Link to="/signup" className="hover:underline text-sm text-gray-700">
          회원가입
        </Link>
      </div>
    )
  }

  const name = user?.user_metadata?.name || '사용자'

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-gray-600 hidden sm:inline font-semibold">{name}님</span>
      <LogoutButton />
    </div>
  )
}
